export const pageFeatures = [
  {
    "feature": "sales",
    url: '/sales',
  },
  {
    "feature": "inventory",
    url: '/inventory',
  },
  {
    "feature": "products",
    url: '/products',
  }, 
  {
    "feature": "stock",
    url: '/stock',
  },
  {
    "feature": "funds",
    url: '/funds',
  },
  {
    "feature": "customers",
    url: '/customers',
  },
  {
    "feature": "debts",
    url: '/debts',
  }
]
export default {
  landingPage: '/',
  login: '/login',
  dashboard: '/dashboard',
  register: '/register',
  sales: '/sales',
  inventory: '/inventory',
  products: '/products',
  funds: '/fund',
  archivedStock: '/archived-stock',
  settings: '/settings',
  customers: '/customers',
  productCategory: '/product-category',
  debts: '/debts',
  resetPassword: "/reset-password",
  pageNotFound: "/page-not-found",
  suppliers: "/suppliers",
  stock: '/stock',
  manageBranchs: '/manage-branchs'
};


